// src/pages/OrderOnTheWay/components/PaymentPendingList.jsx
import React from 'react';
import PaymentPendingCard from './PaymentPendingCard';

const PaymentPendingList = ({ groupedOrders, loading, setAlertMessage }) => {
  const groupEntries = Object.entries(groupedOrders);

  const emptyStateStyle = {
    textAlign: 'center',
    color: '#6b7280',
    padding: '60px 20px',
    fontSize: '18px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    margin: '20px'
  };

  if (groupEntries.length === 0) {
    return (
      <div style={emptyStateStyle}>
        <p>No pending payments.</p>
      </div>
    );
  }

  return (
    <div>
      {groupEntries.map(([seller, group]) => (
        <PaymentPendingCard
          key={seller}
          seller={seller}
          group={group}
          loading={loading}
          setAlertMessage={setAlertMessage}
        />
      ))}
    </div>
  );
};

export default PaymentPendingList;